{
  "NLRTM" : [
    {
      "code" : "MC",
      "name" : "Maascenter",
      "atSea" : true
    },
    {
      "code" : "E13",
      "name" : "Euro 13",
      "atSea" : true
    },
    {
      "code" : "LNG",
      "name" : "LNG",
      "atSea" : true,
      "earlyDeadlineForVisit" : true
    },
    {
      "code" : "RV",
      "name" : "Rendez-vous",
      "atSea" : true,
      "earlyDeadlineForVisit" : true
    },
    {
      "code" : "DH",
      "name" : "Dordrecht-Handelskade",
      "atSea" : false
    },
    {
      "code" : "KAS",
      "name" : "Krammersluis",
      "atSea" : false
    },
    {
      "code" : "KES",
      "name" : "Kreekraksluis",
      "atSea" : false
    },
    {
      "code" : "RB",
      "name" : "Ridderkerk-Bolnes",
      "atSea" : false
    },
    {
      "code" : "VS",
      "name" : "Vluchthaven 's Gravendeel",
      "atSea" : false
    },
    {
      "code" : "VO",
      "name" : "Volkeraksluis",
      "atSea" : false
    }
  ],
  "NLAMS" : [
    {
      "code" : "KP",
      "name" : "Kruispost",
      "atSea" : true
    },
    {
      "code" : "RV",
      "name" : "Rendez-vous",
      "atSea" : true,
      "earlyDeadlineForVisit" : true
    },
    {
      "code" : "AR",
      "name" : "Amsterdam-Rijnkanaal",
      "atSea" : false
    },
    {
      "code" : "OS",
      "name" : "Oranjesluizen",
      "atSea" : false
    },
    {
      "code" : "ZA",
      "name" : "Zaan",
      "atSea" : false
    }
  ],
  "NLDZL" : [],
  "NLHAR" : [],
  "NLSCE" : []
}
